/*!
 * Copyright (c) 2017-present Ghostery GmbH. All rights reserved.
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
/* eslint-disable prettier/prettier */
export default [
    " !important;",
    "-storage-ite",
    "-touch-callo",
    "[href^=\"http",
    "%22%3Afalse%",
    "div[class^=\"",
    "ed-click-ele",
    "ment, button",
    "nt, script, ",
    "trusted-set-",
    "user-select:",
    ", document.",
    ".prototype.",
    "contextmenu",
    "ut: default",
    ":has-text(",
    "!important",
    ".com##+js(",
    "background",
    "flow: auto",
    "container",
    "set-local",
    "2%3Atrue",
    "-webkit",
    ":style(",
    ".*,xham",
    "AAAAAAA",
    "consent",
    "nowoif)",
    "privacy",
    "-wrapp",
    ".co.uk",
    "[class",
    "[data-",
    "[id^=\"",
    "##+js(",
    "accept",
    "banner",
    "bottom",
    "cookie",
    "Cookie",
    "google",
    "policy",
    " text",
    ":has(",
    ".com,",
    "1000)",
    "block",
    "true)",
    ".com",
    ".de,",
    ".fr,",
    ".pl,",
    "#@#.",
    "aeld",
    "gdpr",
    "html",
    "ight",
    "news",
    "s://",
    "www.",
    " > ",
    "##.",
    "###",
    "%5B",
    "%5C",
    "%5D",
    "522",
    "52C",
    "acs",
    "age",
    "ent",
    "tru",
    "web",
    "__",
    "-s",
    ", ",
    ": ",
    ".*",
    ".b",
    ".c",
    ".n",
    ".p",
    ".t",
    "\"]",
    "##",
    "%2",
    "%3",
    "%7",
    "=\"",
    "00",
    "ab",
    "ac",
    "ad",
    "Ad",
    "al",
    "am",
    "an",
    "ap",
    "ar",
    "as",
    "at",
    "bi",
    "bo",
    "ca",
    "ce",
    "ch",
    "ck",
    "ct",
    "d-",
    "da",
    "de",
    "di",
    "do",
    "e-",
    "ed",
    "el",
    "en",
    "er",
    "es",
    "et",
    "eu",
    "fi",
    "fo",
    "g-",
    "ga",
    "ge",
    "go",
    "he",
    "ho",
    "ic",
    "id",
    "if",
    "il",
    "im",
    "in",
    "is",
    "it",
    "la",
    "ld",
    "le",
    "li",
    "lo",
    "ma",
    "me",
    "mo",
    "mp",
    "na",
    "ne",
    "no",
    "ok",
    "ol",
    "om",
    "on",
    "op",
    "or",
    "ot",
    "ov",
    "po",
    "pp",
    "qu",
    "ra",
    "re",
    "ro",
    "ru",
    "s_",
    "s-",
    "sc",
    "se",
    "sh",
    "si",
    "sk",
    "so",
    "sp",
    "ss",
    "st",
    "t-",
    "ta",
    "th",
    "ti",
    "ub",
    "ul",
    "um",
    "un",
    "up",
    "ur",
    "us",
    "ut",
    "ve",
    "vi",
    "y-",
    " ",
    "_",
    "-",
    ",",
    ";",
    ":",
    ".",
    "(",
    ")",
    "[",
    "*",
    "/",
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "a",
    "A",
    "b",
    "B",
    "c",
    "C",
    "d",
    "D",
    "e",
    "E",
    "f",
    "F",
    "g",
    "h",
    "i",
    "I",
    "j",
    "k",
    "l",
    "L",
    "m",
    "M",
    "n",
    "N",
    "o",
    "O",
    "p",
    "P",
    "r",
    "R",
    "s",
    "S",
    "t",
    "T",
    "u",
    "v",
    "w",
    "W",
    "x",
    "y",
    "z"
];
//# sourceMappingURL=raw-cosmetic.js.map